import useRingFeature from '../../hooks/useRingFeature';

const useScheduleMeetingsEnabled = (eventUniqueName: string) => {
    return useRingFeature(eventUniqueName, 'scheduledMeetings');
};

export default useScheduleMeetingsEnabled;
